import type { UserAccount, UserAccountStatusEnum } from "@/lib/api";

export type UserStatusFilter = UserAccountStatusEnum | "all";

export const isActiveUser = (user: UserAccount): boolean => user.status === "active";

export const isInvitedUser = (user: UserAccount): boolean => user.status === "invited";

export const isUnknownUser = (user: UserAccount): boolean => user.status === "unknown";

export const countUsersByStatus = (users: UserAccount[]) => ({
  active: users.filter(isActiveUser).length,
  inactive: users.filter(isInvitedUser).length,
  unknown: users.filter(isUnknownUser).length,
});

export const filterUsersByStatus = (
  users: UserAccount[],
  statusFilter: UserStatusFilter,
): UserAccount[] => {
  if (statusFilter === "active") {
    return users.filter(isActiveUser);
  }

  if (statusFilter === "invited") {
    return users.filter(isInvitedUser);
  }

  if (statusFilter === "unknown") {
    return users.filter(isUnknownUser);
  }

  return users;
};
